module.exports = __webpack_public_path__ + "img/car_shina2_19.9473d7a1.jpg";